import { UI_ROOT } from "../../../app";
//const UI_ROOT = "own";
import  {LogInPage} from "./view/index";




export const LogInView = () => {
    return <LogInPage/>
}